
import { useAuth, AuthLoadingScreen } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import React from "react";
import { useOnboarding } from "@/hooks/useOnboarding";

interface AuthGuardProps {
  children: React.ReactNode;
  skipOnboardingCheck?: boolean;
}

const AuthGuard = ({ children, skipOnboardingCheck }: AuthGuardProps) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const { needsOnboarding, isChecking } = useOnboarding();

  // Show loading screen while auth state is being determined
  if (isLoading || isChecking) {
    return <AuthLoadingScreen />;
  }

  // Redirect to login if no authenticated user
  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Redirect to onboarding if home course not set (unless already on onboarding)
  if (needsOnboarding && !skipOnboardingCheck && location.pathname !== '/courses') {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
